export interface IHit {
	title: string
	svType: string
	date: string,
	isTypeNews: boolean,
	isTypePosition: boolean,
	fileType: string
	city: string
	category: string
	tags: string[]
	description: string
	unbuplishLong: number
	uri: string
}


export interface IValue {
	value: string
	selected: boolean
}

export interface ICategoryFilter {
	name: string
	identifier: string
	values: IValue[]
}
export interface ISort {
	name: string,
	fied: string,
	isDescending: boolean,
	active: boolean
}

export interface IExtraLink {
	name?: string,
	uri?: string,
}

export interface IState {
	query: string,
	searchedQuery: string,
	hits: IHit[],
	date: {
		start: string,
		end: string
	},
	endpoints: {
		search: string,
		suggestions: string
	},
	page: number,
	total: number,
	count: number,
	pages: number,
	categoryFilters: ICategoryFilter[],
	sort: ISort[]
	title: string,
	description: string,
	extraLinks: IExtraLink[],
	suggestions: {
		show: boolean,
		items: string[]
	}
}

const deafultState: IState = {
	query: '',
	searchedQuery: '',
	hits: [],
	date: {
		start: '',
		end: ''
	},
	page: 0,
	count: 0,
	pages: 0,
	endpoints: {
		search: '',
		suggestions: ''
	},
	total: 0,
	categoryFilters: [],
	sort: [],
	title: '',
	description: '',
	extraLinks: [],
	suggestions: {
		show: false,
		items: []
	}
}

export default deafultState;
